import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { externalBankAccountRepository } from '../data-access/repositories/ExternalBankAccountRepository'

const base = ['external-bank-account']

// Prefix of every getExternalBankAccounts(params) key — command Models
// invalidate all list variants through this.
export const EXTERNAL_BANK_ACCOUNT_LIST_BASE_KEY = [...base, 'list']

export const externalBankAccountQueryConfig = {
  getExternalBankAccounts: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...EXTERNAL_BANK_ACCOUNT_LIST_BASE_KEY, params]),
    queryFn: () =>
      externalBankAccountRepository.getExternalBankAccounts(params),
  }),
}
